import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { MainLayout } from "@/components/layout/MainLayout";
import { Helmet } from "react-helmet";
import { AACKeyboard } from "@/components/aac/AACKeyboard";
import { useTranslation } from "@/hooks/useTranslation";

export default function AACKeyboardPage() {
  const { t, dir, lang } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [text, setText] = useState("");

  // Check if we should clear text (coming back from actions page) or receive text (from Communication Board)
  useEffect(() => {
    if (location.state?.clearText) {
      setText("");
      window.history.replaceState({}, document.title);
    } else if (location.state?.text) {
      const incoming = location.state.text;
      // Auto-add trailing space so next word doesn't merge with previous
      setText(incoming && !incoming.endsWith(" ") ? incoming + " " : incoming);
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  const handleDone = () => {
    if (text.trim()) {
      sessionStorage.setItem("sendMessageText", text);
      navigate("/aac-keyboard/send-flow", {
        state: { text }
      });
    }
  };

  const handleBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>{t("aacKeyboardTitle")} - EyeControl App</title>
        <meta
          name="description"
          content={t("aacKeyboardTitle")}
        />
      </Helmet>

      <MainLayout onBack={handleBack}>
        <div className="flex-1 flex flex-col overflow-hidden" dir={dir}>
          <AACKeyboard
            value={text}
            onChange={setText}
            onDone={handleDone}
            uiLanguage={lang}
            className="flex-1"
          />
        </div>
      </MainLayout>
    </>
  );
}
